"use client"; // Next.js 15에서 클라이언트 컴포넌트임을 명시

import { useD3ClientPage } from "@/hook/useD3ClientPage";
import { AppBar, Badge, Box, IconButton, Toolbar, Tooltip, Typography } from "@mui/material";
import { useD3Navigation } from "../provider/NavigationProvider";
import BackButton from "./BackButton";
import ThemeToggle from "./ThemeToggle";
import * as Icons from "@mui/icons-material";
import { Link } from "@/i18n/routing";
import FlagIcon from "./FlagIcon";
import { useD3Fetch } from "@/hook/useD3Fetch";
import { useTranslations } from "next-intl";
export interface TitleAppBarProps {
  title: string;
  countryCode?: string;
  showSearch?: boolean;
  showNoti?: boolean;
  showTheme?: boolean;
  showSignout?: boolean;
}

export default function TiitleAppBar(props: TitleAppBarProps) {
  return (
    <>
      <BaseAppBar {...props} />
      <Toolbar id="back-to-top-anchor" sx={{ minHeight: "56px" }} />
    </>
  );
}

export function BaseAppBar({
  title,
  showSearch = true,
  showNoti = true,
  showTheme = true,
  showSignout = false,
  countryCode,
}: TitleAppBarProps) {
  const t = useTranslations();
  const d3 = useD3Fetch();
  const { goBackOrHome } = useD3Navigation();
  async function handleSignout() {
    const { success } = await d3.get<string>("/auth/signout");
    const res = await fetch("/api/auth/signout");
    const data = await res.json();
    if (data.redirectUrl) {
      window.location.href = data.redirectUrl;
    }
  }
  return (
    <>
      <AppBar color="inherit">
        <Toolbar sx={{ pl: 0 }}>
          <Box
            sx={{
              mx: "auto",
              width: "100%",
              maxWidth: {
                xs: 900, // 예: md 사이즈
                md: 1200, // 예: lg 사이즈
                lg: 1536, // 예: xl 사이즈
              },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <BackButton />
            <Tooltip title={t("tooltip.back")} arrow>
              <Typography
                variant="h4"
                component="h4"
                sx={{
                  cursor: "pointer",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  lineHeight: 1.5,
                  WebkitBoxOrient: "vertical",
                }}
                onClick={goBackOrHome}
              >
                {title}
              </Typography>
            </Tooltip>
            {countryCode && <FlagIcon code={countryCode} size={28} />}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ marginLeft: "auto" }}>
              {showSearch && (
                <IconButton aria-label="search" LinkComponent={Link} href="/search">
                  <Icons.SearchRounded />
                </IconButton>
              )}
              {showNoti && (
                <IconButton aria-label="Notifications">
                  <Badge>
                    <Icons.NotificationsNone />
                  </Badge>
                </IconButton>
              )}
              {showTheme && <ThemeToggle />}
              {showSignout && (
                <Tooltip title="logout" arrow>
                  <IconButton aria-label="logout" onClick={handleSignout}>
                    <Badge>
                      <Icons.LogoutOutlined />
                    </Badge>
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
}
